module.exports = __webpack_public_path__ + "img/heart-manual.62e615f3.png";